import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false
})
export class PageHeaderComponent {
  GroupLabel = "Group"
  /**
   * The page title to show in the header.
   */
  @Input() title: string | undefined;

  /**
   * The subtitle to show below the title (e.g., Claim ID).
   */
  @Input() subtitle: string | undefined;

  /**
   * The group name to show in the header.
   */
  @Input() groupName: string | undefined;
  /**
   * The group number to show in the header.
   */
  @Input() groupNumber: string | undefined;
}